import { instanceOEF, segundaVersaoOEF, instanceApi } from './api'

export const getInfosOpcionais = () => instanceApi.get( `v1/opcionais` )

export const postVendaOpcionais = infoVenda => instanceOEF.post( `${segundaVersaoOEF}/venda-opcional`, infoVenda )

export const postConviteEmailMGM = email => instanceOEF.post( `/email-convite`, { email } )
